import React from 'react'
import { DataProps, WithApolloClient } from 'react-apollo'

import { FormikProps } from 'formik'

import { Address, Profile, User } from 'generated/types'
import { IErrorModalProps } from 'utils/Apollo'
import { WithFlowRouterProps } from 'utils/FlowProvider'

export type AddressProps = {
  address1: string
  address2?: string
  city: string
  state: string
  zip: string
  alsoResidentialAddress?: boolean
}

export enum AddressType {
  Mailing,
  Residential,
}

export type StateProps = {
  addressType: AddressType
  submitAttempted: boolean
  fromSpendConfirmation: boolean
}

export type StateHandlerProps = {
  setAddressType: (addressType: AddressType) => void
  setSubmitAttempted: (value: boolean) => void
}

export type HandlerProps = {
  handleChangeIntercept: (e: React.ChangeEvent) => void
  handleSelectIntercept: (field: string, value: string) => void
  handleSubmitIntercept: () => void
  saveAddress: (addressType: AddressType, values: AddressProps) => Promise<any>
}

type GqlResp = {
  loading: boolean
  user: User
  addresses: Address[]
  profile: Profile
}

export type GqlProps = DataProps<GqlResp>

export type InnerProps = {
  header: string
  text: string
}

export type EnhancedSpendContactInfoProps = InnerProps &
  HandlerProps &
  StateProps &
  StateHandlerProps &
  FormikProps<AddressProps> &
  WithApolloClient<{}> &
  IErrorModalProps &
  WithFlowRouterProps
